import script from "./Inhalt.vue?vue&type=script&setup=true&lang=js"
export * from "./Inhalt.vue?vue&type=script&setup=true&lang=js"

import "./Inhalt.vue?vue&type=style&index=0&id=241f48af&scoped=true&lang=scss"

import exportComponent from "/Users/andrea/Dropbox/espresso/nx01/pcspezi.com/ipspezi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-241f48af"]])

export default __exports__